import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "TreasuryMTBPTemplate" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
